import {useQuery} from "@tanstack/react-query";
import {useEffect} from "react";
import botIcon from "../../../../assets/images/SBX360Bot.png";
import { askToBotService } from '../../../../services/ChatService';
import DialogComponent from '../../../shared/DialogComponent';


type Props = {
    showMenu: boolean;
    selectionText: string;
    optionsToBot: { label: string, instruction: string }[]
    botInstruction?: string
    askToBot: (option: string) => void
    setLoading?: (loading: boolean) => void
    setResult?: (result: string) => void
    sessionId: string
    onClose?: () => void
};


const ChatBotMenuComponent = ({
                                  showMenu,
                                  selectionText,
                                  optionsToBot,
                                  askToBot,
                                  botInstruction,
                                  setResult, sessionId,
                                  setLoading, onClose
                              }: Props) => {


    const {isPending, data, isFetching} = useQuery({
        queryKey: ['bot_api'],
        queryFn: async () => {
            return await askToBotService({session_id: sessionId, question: `${botInstruction}: \n ${selectionText}`})
        },
        enabled: !!botInstruction,
    })

    useEffect(() => {

        if (setResult) {
            if (data?.result) {
                setResult(data.result)
            } else {
                setResult('')
            }
        }


    }, [data, setResult]);

    useEffect(() => {
        if (setLoading) {
            setLoading(isPending || isFetching)
        }
    }, [isPending, isFetching, setLoading]);

    return (
        <div className={`transition ease-in ${showMenu ? "opacity-1 " : "opacity-0"}`}>

            <DialogComponent headerTitle={"Acciones"}
                             onClose={() => {
                                 onClose?.()
                             }}
                             triggerClassname={"rounded-md flex items-center gap-1"} trigger={<>
                <img src={botIcon} alt={"SBX360 bot icon"} className="w-[24px] h-[24px]"/> <span className="text-sm">
                    SBX AI</span>
            </>}>
                {
                    (_, setOpen) => {
                        return <ul className="list-none">
                            {
                                optionsToBot.map((option, index) => (
                                    <li onClick={() => {
                                        if (option?.instruction) {
                                            askToBot(option.instruction)
                                        }
                                        setOpen(false)
                                    }}
                                        key={option?.instruction ?? index}
                                        className=" cursor-pointer p-1 transition-all   duration-100 ease-in
                                        hover:rounded-lg  outline-none text-start hover:bg-blue-gray-50 hover:bg-slate-100 ">
                                        {option.label}
                                    </li>
                                ))
                            }
                        </ul>
                    }
                }

            </DialogComponent>
        </div>
    );
};

export default ChatBotMenuComponent